import { render, staticRenderFns } from "./TextBody.vue?vue&type=template&id=7192e874"
import script from "./TextBody.vue?vue&type=script&lang=js"
export * from "./TextBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports